<template>
  <zj-layout-container>
    <zj-layout-header>
      <div class="listtitle">
        <span>巡更路线详情 - {{ routeName }}</span>
        <el-button size="small" @click="goBack" style="margin-left: 16px;">返 回</el-button>
      </div>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable">
        <div class="zj-table-container">
          <el-tabs v-model="activeTab" @tab-click="onTabClick">
            <el-tab-pane
              v-for="tab in tabs"
              :key="tab.key"
              :name="tab.key"
            >
              <span slot="label" v-html="tabLabel(tab)"></span>
              <el-table
                v-loading="loading"
                element-loading-text="加载中..."
                :data="pagedRows"
                border
                style="width: 100%"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  width="80"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="planName"
                  label="巡更计划"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="planBeginTime"
                  label="计划开始"
                  align="center"
                  :formatter="formatDate"
                ></el-table-column>
                <el-table-column
                  prop="planEndTime"
                  label="计划结束"
                  align="center"
                  :formatter="formatDate"
                ></el-table-column>
                <el-table-column
                  prop="beginTime"
                  label="实际开始"
                  align="center"
                  :formatter="formatDate"
                ></el-table-column>
                <el-table-column
                  prop="endTime"
                  label="实际结束"
                  align="center"
                  :formatter="formatDate"
                ></el-table-column>
                <el-table-column
                  prop="personName"
                  label="巡更员"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="巡更结果"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span :style="routeResultStyle(scope.row.routeResult)">{{ scope.row.routeResult }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="currentTabRows.length"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import { listAllPatrolHistory } from "../../../apis/src/PatrolInspectionApi";
export default {
  name: "PatrolRouteDetailView",
  controller: "UI",
  action: "patrolRouteDetailView",
  data() {
    return {
      routeName: this.$route.query.routeName || "",
      queryBeginTime: this.$route.query.queryBeginTime || null,
      queryEndTime: this.$route.query.queryEndTime || null,
      loading: false,
      allRows: [],
      activeTab: "全部",
      currentPage: 1,
      pageSize: 20,
      tabs: [
        { key: "全部" },
        { key: "准时" },
        { key: "漏巡" },
        { key: "早巡" },
        { key: "晚巡" },
        { key: "补漏巡" },
      ],
      tabCounts: { 全部: 0, 准时: 0, 漏巡: 0, 早巡: 0, 晚巡: 0, 补漏巡: 0 },
    };
  },
  computed: {
    currentTabRows() {
      if (this.activeTab === "全部") return this.allRows;
      return this.allRows.filter((r) => r.routeResult === this.activeTab);
    },
    pagedRows() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.currentTabRows.slice(start, start + this.pageSize);
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    // 拉取与统计页相同时间范围的全部记录，前端按 routeName 过滤出本路线
    loadData() {
      if (!this.routeName) {
        this.errmsg("缺少巡更路线参数");
        return;
      }
      this.loading = true;
      const params = {
        queryBeginTime: this.queryBeginTime || undefined,
        queryEndTime: this.queryEndTime || undefined,
      };
      listAllPatrolHistory(params)
        .then(({ rows }) => {
          this.loading = false;
          this.allRows = (rows || []).filter((r) => r.routeName === this.routeName);
          this.calcCounts();
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    calcCounts() {
      const counts = {
        全部: this.allRows.length,
        准时: 0,
        漏巡: 0,
        早巡: 0,
        晚巡: 0,
        补漏巡: 0,
      };
      this.allRows.forEach((r) => {
        if (r.routeResult && counts[r.routeResult] !== undefined) {
          counts[r.routeResult]++;
        }
      });
      this.tabCounts = counts;
    },
    rate(count, total) {
      if (!total) return "0.0%";
      return ((count / total) * 100).toFixed(1) + "%";
    },
    // 全部 tab 只显示数量；其余 tab 显示 数量 + 率（率=该结果数/该路线总数，1位小数）
    tabLabel(tab) {
      const count = this.tabCounts[tab.key] || 0;
      if (tab.key === "全部") {
        return tab.key + " (" + count + ")";
      }
      return (
        tab.key +
        " (" +
        count +
        ") <span style='color:#909399;margin-left:4px;'>" +
        this.rate(count, this.allRows.length) +
        "</span>"
      );
    },
    onTabClick() {
      this.currentPage = 1;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    goBack() {
      this.$router.back();
    },
    formatDate(row, column) {
      let data = row[column.property];
      if (data == null || data === "") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    },
    routeResultStyle(result) {
      const colorMap = {
        准时: "#67C23A",
        早巡: "#409EFF",
        晚巡: "#E6A23C",
        补漏巡: "#409EFF",
        漏巡: "#F56C6C",
        未知: "#909399",
      };
      return { color: colorMap[result] || "#909399" };
    },
  },
};
</script>
